{
  "title": "Town guides",
  "lead": "Plain guides from the offices that handle each topic, with their upcoming programs and services.",
  "emptyTitle": "No guides yet",
  "emptyBody": "The LGU hasn't set up any town guides yet.",
  "cardNoText": "The office is still writing this guide. Its programs and services are already listed.",
  "from": "From {offices}",
  "allGuides": "All town guides",
  "notFound": "This guide isn't available.",
  "notWrittenTitle": "This guide hasn't been written yet",
  "notWrittenBody": "{offices} will add information here. Until then, see their latest posts, programs and services below.",
  "notWrittenNoOffice": "Information will be added here soon.",
  "linksTitle": "Useful links",
  "postsTitle": "Programs, schedules and announcements",
  "noPosts": "Nothing posted right now. Follow the office to hear about new programs.",
  "servicesTitle": "Services",
  "noServices": "These offices haven't listed their services in the app yet.",
  "allServices": "See all services",
  "contactTitle": "Contact",
  "where": "Where",
  "hours": "Office hours",
  "phone": "Phone",
  "email": "Email",
  "noContact": "Contact details not published yet.",
  "staffLead": "Write the guides your office is responsible for. Residents see them under Town guides, together with your posts and services.",
  "staffEmptyTitle": "No guides assigned to your office",
  "staffEmptyBody": "The LGU administrator assigns town guides to offices.",
  "statusPublished": "Published",
  "statusNotPublished": "Not published",
  "statusNotWritten": "Not written yet",
  "lastEdit": "Last edited by {who} ({office}) on {date}",
  "neverEdited": "Not edited yet",
  "view": "View",
  "backToList": "Back to your guides",
  "editTitle": "Edit: {title}",
  "sharedNote": "This guide is shared by {offices}. Any of them can edit it; the last save is shown to residents.",
  "summary": "Summary",
  "summaryHint": "One or two sentences shown on the guide card. {count} characters left.",
  "body": "Guide text",
  "bodyHint": "What residents need to know: who can avail, what to bring, where to go, schedules.",
  "linksHint": "Official pages only, starting with https://.",
  "linkLabel": "Link text",
  "linkUrl": "Address (https://…)",
  "removeLink": "Remove link {n}",
  "addLink": "Add a link",
  "coverTitle": "Cover photo",
  "coverHint": "Optional. A real photo from your office; skipped in low-data mode.",
  "coverAlt": "Current cover photo",
  "addCover": "Add a photo",
  "replaceCover": "Replace photo",
  "removeCover": "Remove photo",
  "contactNote": "Note on how to reach you",
  "contactNoteHint": "For example: \"Call ahead before going to the RHU.\"",
  "publish": "Show this guide to residents",
  "publishHint": "When off, residents see only your posts and services on this page.",
  "savedPublished": "Saved. Residents can see the guide.",
  "savedDraft": "Saved. The guide isn't shown to residents yet.",
  "adminPageTitle": "Town guides",
  "adminLead": "Decide which guides exist, which offices write each one, and which post categories appear on it. The order here is the order residents see.",
  "adminNew": "New guide",
  "adminEdit": "Edit guide",
  "adminEmpty": "No guides yet",
  "adminSaved": "Guide saved.",
  "adminTitleField": "Title",
  "adminIcon": "Icon",
  "adminOffices": "Offices that write this guide",
  "adminOfficesHint": "Their staff edit the text; their services and contacts appear on the guide.",
  "adminBarangays": "Barangays ({count} chosen)",
  "adminCategories": "Post categories to show",
  "adminCategoriesHint": "Posts in these categories, from any office, appear on the guide. With none, the writing offices' own posts appear.",
  "adminActive": "Show this guide",
  "adminActiveHint": "Hidden guides disappear from the app and from the offices' list.",
  "adminWrittenBy": "Written by {offices}",
  "adminNoOffices": "No office assigned",
  "adminShowsPosts": "Shows posts in: {categories}",
  "adminInactive": "Hidden",
  "moveUp": "Move {title} up",
  "moveDown": "Move {title} down",
  "viewNamed": "View {title}",
  "editNamed": "Edit {title}"
}
